module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 41.93\"><title>quotes</title><path d=\"M29.56,45.48c6.38,0,11.38-2,15-5.91S50,29.44,50,21V3.56H29V22.43H39.13c0,4.62-.75,8.06-2.23,10.31S33,36.12,29.56,36.12v9.37Zm-28.82,0a23.56,23.56,0,0,0,8.52-1.43,16,16,0,0,0,6.39-4.44,20.54,20.54,0,0,0,4-7.67A38.19,38.19,0,0,0,21.09,21V3.56H0V22.43H10.13q0,6.93-2.22,10.31T.74,36.12v9.37Z\" transform=\"translate(0 -3.56)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quotes.svg
// module id = 519
// module chunks = 1